// extracted by mini-css-extract-plugin
export default {"center":"Zgpr2Z","opacityLayer":"c6mOD2"};